import Form from "./components/Form";
import "./App.css";

function App() {
  return (
    <>
      <Form />
    </>
  );
}

export default App;
